import {provideHttpClient} from '@angular/common/http'
import {ApplicationConfig, inject, provideAppInitializer} from '@angular/core'
import {provideAnimationsAsync} from '@angular/platform-browser/animations/async'
import {provideRouter, withHashLocation} from '@angular/router'
import {environment} from '../environments/environment'
import {appRoutes} from './app.routes'
import {ENVIRONMENT} from './application/data-types'
import {LOCAL_STORAGE, SESSION_STORAGE} from './application/providers'
import {BootstrapService} from './services/bootstrap.service'

export const appConfig: ApplicationConfig = {
  providers: [
    {
      provide: SESSION_STORAGE,
      useValue: sessionStorage
    },
    {
      provide: LOCAL_STORAGE,
      useValue: localStorage
    },
    {
      provide: ENVIRONMENT, useValue: environment
    },
    provideAppInitializer(() => inject(BootstrapService).bootstrap()),
    provideRouter(appRoutes, withHashLocation()),
    provideAnimationsAsync(),
    provideHttpClient()
  ]
}